// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__Fp+FI","moveUpDown":"Profile_moveUpDown__BGRXf","btnNotHover":"Profile_btnNotHover__gFVA7","btnHover":"Profile_btnHover__Y047W"};